import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'

import './plugins/filter'
import './plugins/vee-validate'
import httpClient from './plugins/http-client'

import Vuetify from 'vuetify'
import VuetifyDatetimePicker from 'vuetify-datetime-picker'
import VueLazyLoad from 'vue-lazyload'

import HelperMixin from './mixins/helper-mixin'


import 'vuetify/dist/vuetify.min.css'
import ja from 'vuetify/es5/locale/ja'
import '@mdi/font/css/materialdesignicons.css'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import VueHead from 'vue-head'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import Vue2Editor from 'vue2-editor'
import { BigNumber } from 'bignumber.js';
import 'dayjs/locale/ja';
import dayjs from "dayjs";
import CsDatePicker from "./components/CsDatePicker.vue";
import RecycleStepTable from "./driver/components/RecycleStepTable.vue";

dayjs.locale("ja");

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
Vue.component('CsDatePicker', CsDatePicker)
Vue.component('RecycleStepTable', RecycleStepTable)
import './sass/variables.scss'

Vue.use(Vuetify)
Vue.use(VuetifyDatetimePicker)
Vue.use(VueLazyLoad)
Vue.use(VueHead)
Vue.mixin(HelperMixin)
Vue.use(Vue2Editor)
Vue.use(BigNumber)
Vue.prototype.$dayjs = dayjs


import VueGtag from 'vue-gtag'
if (process.env.VUE_APP_ENV === 'production') {
  Vue.use(VueGtag, {
    config: {
      id: 'GTM-NWJHL89'
    }
  }, router)
}


const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: {ja},
    current: 'ja'
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#0070B3',
        info: '#00AAD1',
      }
    }

  }
})
Vue.config.productionTip = false
Vue.use(httpClient, { store })

Vue.config.errorHandler = function (error) {

  if (error.name === 'NavigationDuplicated') {
    // routerで遷移する時、同じページに遷移しようとすると起こるエラーを回避
    return
  }
}


router.beforeEach((to, from, next) => {
  // console.log('■■to_path', to.path)
  if (to.path.match(/driver-app/)) {
    next()
  } else if (to.path.match(/driver/)) {
    setTimeout(function() {
      store.commit('alertMessage/reset')
      store.commit('snackbar/hide')
    }, 5000)
    const meta = to.meta || {}
    let expiresTime = store.state.DriverAuthentication.expiresTime
    if (to.path.match(/notfound/)) {
      next()
    } else if ((expiresTime && (expiresTime > (new Date()).getTime())) || to.meta.isPublic) {
      next()
    } else {
      next({path: '/driver', query: { backuri: to.fullPath }})
    }
  } else if (to.path.match(/admin/)) {

    let expiresTime = store.state.AdminAuthentication.expiresTime
    // if ((expiresTime && (expiresTime > (new Date()).getTime())) || to.name === 'AdminSession') {
    if ((expiresTime && (expiresTime > (new Date()).getTime())) || to.meta.isPublic) {
      next()
    } else {
      next({path: '/admin', query: { backuri: to.fullPath }})
    }
  } else if (to.path.match(/edi_request/)) {
    next()
  } else {
    next()
  }
})

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: '#app',
    store: store,
    router,
    vuetify: vuetify,
    render: (h) => h(App)
  }).$mount("#app");
})
